import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Stack,
  Box,
  Chip,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

export default function SubmissionDetailsAccordion({
  userName,
  userEmail,
  userPhone,
  userRole,
  accountId,
  linkedAccountIds = [],
  route,
  environment,
}) {
  return (
    <Accordion
      disableGutters
      elevation={0}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '8px !important',
        '&:before': { display: 'none' },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="caption" fontWeight={700} color="text.secondary">
          Submission details (auto-collected)
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0 }}>
        <Stack spacing={0.75} sx={{ fontSize: '0.78rem', color: 'text.secondary' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>Reporter:</span>
            <strong>{userName || userEmail || 'Logged in user'}</strong>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>Email:</span>
            <strong>{userEmail || 'N/A'}</strong>
          </Box>
          {userPhone && (
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <span>Phone:</span>
              <strong>{userPhone}</strong>
            </Box>
          )}
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>Role:</span>
            <Chip label={userRole} size="small" sx={{ textTransform: 'capitalize', height: 20 }} />
          </Box>
          {accountId && (
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <span>Account ID:</span>
              <code>{accountId}</code>
            </Box>
          )}
          {linkedAccountIds.length > 0 && (
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <span>Linked Accounts:</span>
              <code>{linkedAccountIds.join(', ')}</code>
            </Box>
          )}
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>Route:</span>
            <code>{route || '/'}</code>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Environment:</span>
            <Chip
              label={environment || 'prod'}
              size="small"
              sx={{ height: 20, fontSize: '0.72rem', textTransform: 'uppercase', fontWeight: 700 }}
            />
          </Box>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
